import { render } from "./LightboxPreviewImageList.vue?vue&type=template&id=0195e2b8&scoped=true"
import script from "./LightboxPreviewImageList.vue?vue&type=script&lang=js"
export * from "./LightboxPreviewImageList.vue?vue&type=script&lang=js"

import "./LightboxPreviewImageList.vue?vue&type=style&index=0&id=0195e2b8&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0195e2b8"]])

export default __exports__